export const getErroMessage = (errorCode, setError) => {
  switch (errorCode) {
    case 'auth/email-already-in-use':
      setError('Este e-mail já está em uso. Tente fazer login ou use um e-mail diferente.');
      break;
    case 'auth/invalid-email':
      setError('O e-mail fornecido não é válido.');
      break;
    case 'auth/weak-password':
      setError('A senha deve ter pelo menos 6 caracteres.');
      break;
    case 'auth/missing-email':
      setError('O e-mail é obrigatório.');
      break;
    case 'auth/missing-password':
      setError('A senha é obrigatória.');
      break;
    case 'auth/network-request-failed':
      setError('Falha na conexão com a rede. Verifique sua conexão e tente novamente.');
      break;
    case 'auth/user-not-found':
    case 'auth/invalid-credential':
      setError('Email ou senha incorretos. Tente novamente.');
      break;
    case 'auth/user-disabled':
      setError('Essa conta foi desativada.');
      break;
    // Novas mensagens de erro para o registro
    case 'invalid-code': // Para erros de código
      setError('O código fornecido é inválido ou não existe.');
      break;
    case 'auth/operation-not-allowed':
      setError('A operação não é permitida. Contate o suporte.');
      break;
    default:
      setError('Ocorreu um erro. Tente novamente.');
      break;
  }
};
